var map = {
	"./de-CH/config.json": 13225,
	"./de/config.json": 27534,
	"./en/config.json": 78863,
	"./es/config.json": 25946,
	"./fr-CA/config.json": 44317,
	"./fr-CH/config.json": 78125,
	"./fr/config.json": 96727,
	"./it-CH/config.json": 6025,
	"./it/config.json": 62715,
	"./ro/config.json": 57031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82599;